<template>
	<div>
		<ConfirmTool ref="confirm"></ConfirmTool>
		<div class="d-flex pa-2" 	v-if="
					booking.BookingStatusId === BookingStatusIdEnum.BOOKED ||
						booking.BookingStatusId ===
							BookingStatusIdEnum.WAITINGFORPAYMENT
				">

			<v-btn
				color="#25D366"
				dark
				small
				@click="sendWhatsappNotification"
				class="ml-2"
				v-if="moment(booking.BookingTime).isSame(moment(), 'day')"
				:loading="sendingWhatsappNotification"
			>
				<v-icon small>fab fa-whatsapp</v-icon>
			</v-btn>

			<v-spacer></v-spacer>

			<template
				v-if="
					booking.BookingStatusId === BookingStatusIdEnum.BOOKED ||
						booking.BookingStatusId ===
							BookingStatusIdEnum.WAITINGFORPAYMENT
				"
			>
				<v-btn
					color="nyrose"
					dark
					small
					@click="ShowCancelBookingDialog"
					:loading="loadingData"
					class="ml-2"
				>
					<v-icon small >far fa-times</v-icon>
				</v-btn>
				<v-btn
					color="nyblue"
					dark
					small
					@click="openModifyBookingDialog"
					:loading="loadingData"
					class="ml-2"
				>
					<v-icon small>far fa-edit</v-icon>
				</v-btn>
			</template>
			<template
				v-if="booking.BookingStatusId === BookingStatusIdEnum.BOOKED"
			>
				<v-btn
					color="success"
					dark
					small
					@click="CompleteBooking"
					:loading="loadingData"
					class="ml-2"
				>
					<v-icon small>far fa-check</v-icon>
				</v-btn>

				<!--        <v-btn color="" @click="" :loading="loadingData">{{-->
				<!--					$t("CompleteBooking")-->
				<!--					}}-->
				<!--        <v-icon right>far fa-check</v-icon>-->
				<!--      </v-btn>-->
			</template>
		</div>
		<v-dialog max-width="400" v-model="showCancelBookingDialog">
			<v-card>
				<v-card-title>{{ $t("CancelBooking") }} </v-card-title>
				<v-card-text>
					Stai per annullare l'appuntamento.

					<br />
					<strong>
						ATTENZIONE: se invece vuoi spostare questo appuntamento,
						NON CANCELLARLO ma premi sul pulsante MODIFICA.</strong
					>
					<br />
					<v-select
						:items="cancelReasons"
						label="Seleziona il motivo dell'annullamento:"
						v-model="selectedCancelReason"
						item-text="Text"
						item-value="Value"
					>
					</v-select>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="showCancelBookingDialog = false">{{
							$t("common.back")
						}}</v-btn>
					<v-btn
						color="error"
						@click="CancelBooking"
						:loading="loadingData"
						:disabled="selectedCancelReason === null"
					>{{ $t("common.cancel") }}</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="400" v-model="showModifyDialog"
		><v-card
		><v-card-title>Modifica la data e ora </v-card-title>
			<v-card-text>
				<DateTimePicker v-model="newDataTime"></DateTimePicker>
				<!-- {{ booking.BookingTime | formatDateTime }} -->
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="showModifyDialog = false" text>{{
						$t("common.cancel")
					}}</v-btn>
				<v-btn @click="UpdateDateTime" color="primary">{{
						$t("common.update")
					}}</v-btn>
			</v-card-actions>
		</v-card></v-dialog
		>
	</div>
</template>

<script>
import moment from "moment/moment";
import DateTimePicker from "@/components/Shared/FormControl/DateTimePicker.vue";
import { mapActions } from "vuex";
import ConfirmTool from "@/components/Shared/Common/Confirm.vue";
import { BookingStatusIdEnum } from "@/components/NutriYou/nutriYouBookingStatusEnum";
import { BookingTypesEnum } from "@/components/NutriYou/nutriYouBookingTypesEnum";
import CrudClient from "@/services/CrudClient";
export default {
	name: "NutritionistBookingListActions",
	components: { DateTimePicker, 		ConfirmTool, },
	data() {
		return {
			showModifyDialog: false,
			newDataTime: null,
			loadingData: false,
			showCancelBookingDialog: false,
			selectedCancelReason: null,
			cancelReasons: [
				{ Value: 2, Text: "Annullato per scelta del paziente" },
				{ Value: 3, Text: "Paziente non era presente" },
				{ Value: 5, Text: "Annullato per riprogrammare in futuro" },
				{ Value: 4, Text: "Appuntamento creato per errore" },
				{ Value: 1, Text: "Annullato per scelta del nutrizionista" }
			],
			showBillingInfoDialog: false,
			BillingProfile: null,
			LoadingBillingInfo: false,
			sendingWhatsappNotification: false
		}
	},
	props: {
		booking: { type: Object, required: true },
	},
	created() {
		this.BookingStatusIdEnum = BookingStatusIdEnum;
		this.BookingTypesEnum = BookingTypesEnum;
		this.moment = moment;
		this.BookingsService = new CrudClient("CurrentNutritionist/Bookings");
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		ShowCancelBookingDialog() {
			this.showCancelBookingDialog = true;

			if (this.booking.BookingTypeId !== BookingTypesEnum.FREE) {
				this.cancelReasons = this.cancelReasons.filter(
					r => r.Value !== 3
				);
			}
		},

		async CancelBooking() {
			try {
				this.loadingData = true;
				await this.BookingsService.Post(
					this.booking.BookingId,
					null,
					"CancelBooking?cancelReasonId=" + this.selectedCancelReason
				);
				this.$emit("bookingModified");
			} catch (error) {
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
				this.$captureError(error);
			} finally {
				this.loadingData = false;
				this.showCancelBookingDialog = false;
			}
		},

		async sendWhatsappNotification() {
			if (
				!(await this.$refs.confirm.open(
					"Messaggio Whatsapp",
					"Stai per inviare una notifica Whatsapp al tuo paziente per avvertirlo che c’è un tuo messaggio urgente da leggere in chat",
					{ color: "warning" }
				))
			) {
				return 1;
			}

			try {
				this.sendingWhatsappNotification = true;
				await this.PatientsService.Post(
					this.booking.PatientUserId,
					null,
					"SendUrgentChatMessageNotification",
					false
				);
				this.snackSuccess({
					Text: this.$t("common.success.messageSent")
				});
			} catch (error) {
				this.snackError({
					Header: "Impossibile inviare il messaggio",
					Text: "Manca il numero di telefono dell'utente"
				});
				this.$captureError(error);
			} finally {
				this.sendingWhatsappNotification = false;
			}
		},

		openModifyBookingDialog() {
			this.showModifyDialog = true;
			this.newDataTime = this.booking.BookingTime;
		},

		async UpdateDateTime() {
			if (
				!(await this.$refs.confirm.open(
					this.$t("ModifyBooking"),
					"Sei sicuro di voler modificare la data dell'appuntamento?",
					{ color: "warning" }
				))
			) {
				return 1;
			}
			try {
				this.loadingData = true;
				const dto = { BookingTime: this.newDataTime };
				await this.BookingsService.Post(
					this.booking.BookingId,
					dto,
					"ModifyBookingTime"
				);
				this.$log.debug("bookingModified");
				this.$emit("bookingModified");

				this.showModifyDialog = false;
			} catch (error) {
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
				this.$captureError(error);
			} finally {
				this.loadingData = false;
			}
		},

		async CompleteBooking() {
			if (
				!(await this.$refs.confirm.open(
					this.$t("CompleteBooking"),
					"Sei sicuro di voler completare l'appuntamento?",
					{ color: "warning" }
				))
			) {
				return 1;
			}
			try {
				this.loadingData = true;
				await this.BookingsService.Post(
					this.booking.BookingId,
					null,
					"Complete"
				);
				this.$emit("bookingModified");
			} catch (error) {
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
				this.$captureError(error);
			} finally {
				this.loadingData = false;
			}
		}
	}

}

</script>

<style scoped lang="scss">

</style>
